import { bimParamsAPI } from "@/views/BimParams/services/api";

export const getBimParams = async () => {
  try {
    const res = await bimParamsAPI.getList();
    return res?.data;
  } catch (e) {}
};

export const saveBimParam = async (data) => {
  try {
    const res = await bimParamsAPI.save(data);
    return res;
  } catch (e) {}
};

export const deleteBimParam = async (bim_param_id) => {
  try {
    const res = await bimParamsAPI.delete(bim_param_id);
    return res;
  } catch (e) {}
};

export const getBufferProperties = async () => {
  try {
    const res = await bimParamsAPI.getBufferProperties();
    return res?.data;
  } catch (e) {}
};

